<template>
  <div>
    <div v-if="type != TYPE_BANK">
      <el-input type="number" v-model.number="childValue" class="h-40 mw-240" :placeholder="placeholder" :disabled="disabled" v-if="typeNumber" @input="change(childValue)" :maxlength="maxLength"></el-input>
      <el-input v-model.trim="childValue" class="h-40 mw-240" :placeholder="placeholder" :disabled="disabled" @input="change(childValue)" :maxlength="maxLength" v-else></el-input>
    </div>
    <div v-else>
      <el-input v-model="childValue" class="h-40 mw-240" :placeholder="placeholder" :disabled="disabled" @input="change(childValue)" :maxlength="maxLength" @change="bankNumber"></el-input>
    </div>
  </div>
</template>
<script>
  /**
   * @param Number value 绑定值
   * @param Number type 类型
   * @param String name 控件名
   * @param Boolean disabled 是否禁用
   * @param Array rules 表单验证规则
   * @param String placeholder 提示语
   * @param Number minLength 最小输入长度
   * @param Number maxLength 最大输入长度
   * @param String defaultValue 默认值
   */
  import modelConfig from '../../../../config/modelConfig'
  import _verify from '../../../../assets/js/verify'
  import http from '../../../../assets/js/http'
  export default {
    props: ['type', 'value', 'name', 'disabled', 'rules', 'placeholder', 'minLength', 'maxLength', 'defaultValue', 'decimal', 'isNeed', 'modelId', 'fieldId', 'isUnique'],
    data() {
      return {
        childValue: null,
        sourceValue: null
      }
    },
    created() {
      this.initData()
      this.setRules()
    },
    methods: {
      initData() {
        if (!_g.isRealEmpty(this.value)) {
          this.childValue = this.value
          this.sourceValue = this.value
        } else if (this.value == null) { // 空值
          this.setDefaultValue()
        } else {
          this.childValue = ''
        }
      },
      setRules() {
        if (this.rules) {
          if (this.isNeed) {
            if (this.minLength) {
              this.rules[this.name].push({ validator: this.checkMinLength, trigger: 'blur' })
            }
            if (this.maxLength) {
              this.rules[this.name].push({ validator: this.checkMaxLength, trigger: 'blur' })
            }
          }
          if (this.isUnique) {
            this.rules[this.name].push({ validator: this.checkDataUnique, trigger: 'blur' })
          }
          if (this.type == this.TYPE_NUMBER) {
            // 限定数字
            this.rules[this.name].push({ validator: this.isNumber, trigger: 'blur' })
          } else if (this.type == this.TYPE_ENGLISH) {
            // 英文
            this.rules[this.name].push({ validator: this.isEnglish, trigger: 'blur' })
          } else if (this.type == this.TYPE_EMAIL) {
            // 邮箱
            this.rules[this.name].push({ type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' })
          } else if (this.type == this.TYPE_PHONE) {
            // 手机
            this.rules[this.name].push({ validator: this.isPhone, trigger: 'blur' })
          } else if (this.type == this.TYPE_NUM_OR_ENG) {
            // 数字和英文
            this.rules[this.name].push({ validator: this.isEngAndNum, trigger: 'blur' })
          } else if (this.type == this.TYPE_IDCARD) {
            // 身份证号码
            this.rules[this.name].push({ validator: this.isIdCard, trigger: 'blur' })
          } else if (this.type == this.TYPE_FLOATNUMBER) {
            // 小数点验证
            this.rules[this.name].push({ validator: this.isDecimal, trigger: 'blur' })
          } else if (this.type == this.TYPE_BANK) {
            // 银行账号验证
            this.rules[this.name].push({ validator: this.checkMaxLength, trigger: 'blur' })
          }
        }
      },
      setDefaultValue() {
        if (this.defaultValue) {
          this.childValue = this.defaultValue
        } else {
          this.childValue = ''
        }
        this.change(this.childValue)
      },
      isNumber(rule, value, callback) {
        if (!_verify.isNumber(value)) {
          callback(new Error('请输入整数'))
        } else if (value != '' && _verify.isDecimal(value)) {
          callback(new Error('请输入整数'))
        } else {
          callback()
        }
      },
      isEnglish(rule, value, callback) {
        if (!_verify.isEnglish(value)) {
          callback(new Error('请输入英文'))
        } else {
          callback()
        }
      },
      isPhone(rule, value, callback) {
        if (!_verify.isPhone(value)) {
          callback(new Error('请输入正确的手机号码'))
        } else {
          callback()
        }
      },
      isEngAndNum(rule, value, callback) {
        if (!_verify.isEngAndNum(value)) {
          callback(new Error('请输入数字或英文'))
        } else {
          callback()
        }
      },
      isIdCard(rule, value, callback) {
        if (!_verify.isIdCard(value)) {
          callback(new Error('请输入正确的身份证号码'))
        } else {
          callback()
        }
      },
      isDecimal(rule, value, callback) {
        // decimal为0时，只能输入整数，后台自动补齐两小数点位
        // decimal不为0时，可输入整数decimal数值为最大小数点位，小数点位不能超过该数值
        if (!this.disabled) {
          if (this.decimal == 0) {
            if (_verify.isNumber(value) && !_verify.isDecimal(value)) {
              let len = this.maxLength - 2
              if (value.toString().length > len) {
                callback(new Error('整数位和默认2位小数的总长度超过' + this.maxLength + '位'))
              } else {
                callback()
              }
            } else {
              callback(new Error('只能输入整数'))
            }
          } else {
            if (value && value > 0) {
              if (_verify.isNumber(value) && !_verify.isDecimal(value)) {
                callback()
              } else if (value.toString().split('.')[1].length <= this.decimal) {
                let len = this.maxLength - this.decimal
                if (value.toString().split('.')[0].length > len) {
                  callback(new Error('整数位和小数位的总长度超过' + this.maxLength + '位'))
                } else {
                  callback()
                }
              } else {
                callback(new Error('小数位不能超过' + this.decimal + '位'))
              }
            } else {
              callback()
            }
          }
        } else {
          callback()
        }
      },
      isBankAccount(rule, value, callback) {
        if (_verify.isBankAccount(value)) {
          // let len = 0
          // for (let i = 0; i < value.length; i++) {
          //   if (value[i] != ' ') {
          //     len++
          //   }
          // }
          callback()
          // if (len <= 19) {
          //   callback()
          // } else {
          //   callback(new Error('银行账号最多为19位'))
          // }
        } else {
          callback(new Error('请输入正确的银行账号'))
        }
      },
      bankNumber() {
        this.childValue = this.childValue.replace(/\s/g,'').replace(/(\d{4})(?=\d)/g,"$1 ")
        this.change(this.childValue)
      },
      checkMinLength(rule, value, callback) {
        if (value.length < this.minLength) {
          callback(new Error(`请输入${this.minLength}~${this.maxLength}位字符`))
        } else {
          callback()
        }
      },
      checkMaxLength(rule, value, callback) {
        if (value.length > this.maxLength) {
          callback(new Error(`请输入${this.minLength ? this.minLength : 0}~${this.maxLength}位字符`))
        } else {
          callback()
        }
      },
      async checkDataUnique(rule, value, callback) {
        if (this.sourceValue == this.childValue) {
          callback()
          return
        }
        let postData = {
          value: this.childValue
        }
        let res = await this.apiPost(`form/models/${this.modelId}/check/${this.fieldId}`, postData)
        if (res.code == 200) {
          callback()
        } else {
          callback(new Error(`“${this.childValue}”已存在，请重新输入`))
        }
      },
      change(value) {
        this.$emit('input', value)
      }
    },
    watch: {
      'value'() {
        if (this.value != this.childValue) {
          this.initData()
        }
      }
    },
    computed: {
      typeNumber() {
        return this.type == this.TYPE_NUMBER ||
               this.type == this.TYPE_FLOATNUMBER ||
               this.type == this.TYPE_FORMULA
      }
    },
    mixins: [modelConfig, http]
  }
</script>


// WEBPACK FOOTER //
// honrayInput.vue?0bef4cf1